// What the admin reads when moderateRating refuses (spec 026 D24). The SDK's
// `code` is the reliable part ("functions/<status>"); the server's own message is
// the sentence to show for everything it wrote one for. `not-found` is the one
// case with no server sentence: the callable is not deployed on the project this
// dashboard points at — which, before the cutover, is production.
export const moderationErrorMessage = (e) => {
  if (e?.code === "functions/not-found") {
    return "Rating moderation is not deployed on this project yet.";
  }
  return e?.message || "Failed to remove the rating.";
};
